import { Button, CancelIcon } from '@aleph/shared-components';

interface IProps {
	loading?: boolean
	showSuffix?: boolean
	onCancel: () => void
	onConfirm: () => void
}

function EntityEditInputSuffix({
	loading,
	showSuffix,
	onConfirm,
	onCancel,
}: IProps) {
	return showSuffix
		? (
			<>
				<Button
					leftNode={<CancelIcon />}
					appearance="ghost"
					color="gray"
					size="small"
					onClick={onCancel}
					disabled={loading}
				/>
				<Button title="Save changes"
					size="small"
					onClick={onConfirm}
					disabled={loading}
				/>
			</>
		)
		: null;
}

export default EntityEditInputSuffix;
